<template>
  <div class="dod29">
    <div ref="dod29">
      <h1 class="dod29_textAnime">
        <span class="line">Days of Design</span>
      </h1>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'Day29',

  data: () => ({
  }),

  computed: {
  },

  methods: {
    init() {
      const els = this.$refs.dod29.querySelectorAll('.dod29_textAnime .line')
      for (let el of els) {
        el.innerHTML = el.textContent.replace(/(\w)/g, '<span class="word">$&</span>')
      }

      anime.timeline({ loop: true })
        .add({
          targets: '.dod29_textAnime .word',
          translateX: ['-5%', '0%'],
          translateY: ['100%', '0%'],
          translateZ: 0,
          opacity: [0, 1],
          skewX: ['45deg', '0deg'],
          easing: 'easeOutExpo',
          duration: 1400 * 0.8,
          delay: (el, i) => {
            return 300 + 50 * i - i * 15
          }
        }).add({
          targets: '.dod29_textAnime .word',
          opacity: [1, 0],
          easing: 'easeInExpo',
          duration: 2000,
          delay: 500
        })
    }
  },

  beforeDestroy() {
  },

  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.dod29 {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center);
  overflow: hidden;
}
.dod29_textAnime {
  font-size: 10vmin;
  font-weight: 700;
  letter-spacing: -0.015em;
}
.dod29_textAnime .line {
  display: block;
  line-height: 1em;
  transform-origin: 0 0;
}
.dod29_textAnime .line .word {
  display: inline-block;
  line-height: 1em;
  transform-origin: 0 0;
  // text-transform: uppercase;
}
</style>
